module.exports = __webpack_public_path__ + "img/30.14d468c0.png";